export default __webpack_public_path__ + "static/media/backArrow.c3f42672.svg";